import React, {useEffect, useState} from "react";
import {axiosInstance} from "../utilities/AxiosConfig";
import Cookies from "js-cookie";
import {notify} from "../components/toast";
import {ToastContainer} from "react-toastify";
import {MunshiMenu} from "../components/Menu";
import {jDateToMySql} from "../utilities/ToMySqlDate";
import DashBoardPanel from "../components/Manufacturing/DashBoardPanel";
import {generateRandomString} from "../utilities/randomGenerator";
import {useSpinner} from "../context/SpinnerContext";
import {Auths} from "../utilities/getAuthDep";




export const DashBoard = ({handle}) => {
    const {loading, setLoading} = useSpinner()
    const [inputList, setInputList] = useState();
    const [outputList, setOutputList] = useState();
    const [kitUsed, setKitUsed] = useState([])
    const [companyName, setCompanyName] = useState("");
    const [level] = useState(Auths);
    const [user, setUser] = useState("Guest");
    const [database, setDatabase] = useState("Test");

    const [mfxList, setMfxList] = useState([]);
    const [expList, setExpList] = useState([]);
    const [locationList, setLocationList] = useState([]);

    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                // Fetch all data in parallel for better performance
                const [locRes] = await Promise.all([
                    axiosInstance.get('location'),
                ]);
                setLocationList(locRes.data);
            } catch (error) {
                notify(error.message, "error");
            } finally {
                setLoading(false);
            }
        };
        fetchInitialData();
    }, []);
    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`/customer/status/M`).then((response) => {
            setMfxList(response.data)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
           setLoading(false)
        )
    }, [])
    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`/customer/status/E`).then((response) => {
            setExpList(response.data)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
           setLoading(false)
        )
    }, [])
    useEffect(() => {
        setUser(Cookies.get('user') || "Guest");
        setDatabase(Cookies.get('database') || "Test");
    }, [])
    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`biodata/`,).then((response) => {
            setCompanyName(response.data.name)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            () => {
                setLoading(false)
            }
        )
    }, []);
    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`/mfx/pendings/`).then((response) => {
            setInputList(response.data.input)
            setOutputList(response.data.output)
            setKitUsed(response.data.kitUsed)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }, [])

    const processData = async (_inputLists, _defectLists, _selectedMfxs, _selectedExps, _selectedDate, _selectedLocation) => {
        try {
            const cleanDefectList = _defectLists.filter(it => it.name !== "")
            if (cleanDefectList.length > 0 && _selectedExps.id > 0) {
                const header = {
                    id: 0,
                    customerId: _selectedExps.id,
                    customerName: _selectedExps.name,
                    date: _selectedDate,
                    status: [{
                        name: "Approval",
                        date: _selectedDate,
                        user: "Mfx",
                        status: true
                    }, {
                        name: "Ready",
                        date: _selectedDate,
                        user: "Mfx",
                        status: true
                    }, {
                        name: "Invoiced",
                        date: _selectedDate,
                        user: "Mfx",
                        status: true
                    }, {
                        name: "Delivered",
                        date: _selectedDate,
                        user: "Mfx",
                        status: true
                    }],
                    posted: false,
                    location: _selectedLocation,
                    total: 0,
                    vat: 0,
                    comment: "Mfx Defects"
                }
                const invoiceContent = cleanDefectList.map(it => {
                    return {
                        id: generateRandomString(4),
                        invoiceId: 0,
                        itemId: it.id,
                        itemName: it.name,
                        quantity: it.quantity,
                        price: 0.0,
                        lastPrice: 0.0,
                        stock: 0,
                        total: 0,
                        comment: "Mfx Defects"
                    }
                })
                const serialList = []
                setLoading(true)
                const response = await axiosInstance.post("invoice", {
                    header: header,
                    body: invoiceContent,
                    serialList: serialList
                })
                if (response.data === 0) {
                    notify("Invoice could not be saved. Please try again.", "error")
                } else {
                    notify(`Defect Invoice ${response.data} Saved Successfully`, "success")
                }
            }

            if (kitUsed.length > 0) {
                const ttl = kitUsed.reduce(
                    (acc, it) => acc + (Number(it?.price) || 0) * (Number(it?.quantity) || 0),
                    0
                )
                const header = {
                    id: 0,
                    customerId: _selectedMfxs.id,
                    customerName: _selectedMfxs.name,
                    date: _selectedDate,
                    status: [{
                        name: "Approval",
                        date: jDateToMySql(_selectedDate),
                        user: "Mfx",
                        status: true
                    }, {
                        name: "Ready",
                        date:  jDateToMySql(_selectedDate),
                        user: "Mfx",
                        status: true
                    }, {
                        name: "Invoiced",
                        date:  jDateToMySql(_selectedDate),
                        user: "Mfx",
                        status: true
                    }, {
                        name: "Delivered",
                        date:  jDateToMySql(_selectedDate),
                        user: "Mfx",
                        status: true
                    }],
                    posted: false,
                    location: _selectedLocation,
                    total: ttl,
                    vat: 0,
                    comment: "Mfx Input"
                }
                const invoiceContent = kitUsed.map(it => {
                    return {
                        id: generateRandomString(4),
                        invoiceId: 0,
                        itemId: it.id,
                        itemName: it.name,
                        quantity: it.quantity,
                        price: it.price,
                        lastPrice: 0.0,
                        stock: 0,
                        total:  it.quantity*it.price,
                        comment: "Mfx Input"
                    }
                })
                const serialList = []
                setLoading(true)
                const response = await axiosInstance.post("invoice", {
                    header: header,
                    body: invoiceContent,
                    serialList: serialList
                })
                if (response.data === 0) {
                    notify("Input could not be saved. Please try again.", "error")
                } else {
                    notify(`Input Invoice ${response.data} Saved Successfully`, "success")
                }
            }
            if (outputList.length > 0 && _selectedMfxs.id > 0) {
                setLoading(true)
                const contentList = outputList.map(it => {
                    return {
                        id: generateRandomString(4),
                        invoiceId: 0,
                        itemId: it.itemId,
                        itemName: it.itemName,
                        quantity: it.quantity,
                        price: it.price,
                        total: it.price * it.quantity,
                        comment: "Mfx"
                    }
                })
                const ttl = outputList.reduce((a, b) => a + (b.price * b.quantity), 0)
                setLoading(true)
                const response = await axiosInstance.post('purchase', {
                    header: {
                        id: 0,
                        customerId: _selectedMfxs.id,
                        customerName: _selectedMfxs.name,
                        date: _selectedDate,
                        warranty: false,
                        import: false,
                        posted: false,
                        location: _selectedLocation,
                        total: ttl,
                        vat: 0,
                    }, body: contentList, serial: []
                })
                if (response.data === 0) {
                    notify("Purchase could not be saved. Please try again.", "error")
                } else {
                    notify("Purchased Saved Successfully", "success")
                }

            }
            let rawData = []
            if (outputList.length > 0 && _selectedMfxs.id > 0) {
                const outputData = outputList.map(it => {
                    return {
                        id: 0,
                        date: jDateToMySql(_selectedDate),
                        itemId: it.itemId,
                        itemName: it.itemName,
                        quantity: it.quantity,
                        code: "",
                        status: "PURC",
                    }
                })
                rawData = rawData.concat(outputData)
            }
            if (cleanDefectList.length > 0 && _selectedExps.id > 0) {
                const defectData = _defectLists.map(it => {
                    return {
                        id: 0,
                        date: jDateToMySql(_selectedDate),
                        itemId: it.id,
                        itemName: it.name,
                        quantity: it.quantity,
                        code: "",
                        status: "SALE",
                    }
                })
                rawData = rawData.concat(defectData)
            }
            if (kitUsed.length > 0) {
                const kitData = kitUsed.map(it => {
                    return {
                        id: 0,
                        date: jDateToMySql(_selectedDate),
                        itemId: it.id,
                        itemName: it.name,
                        quantity: it.quantity,
                        code: "",
                        status: "SALE",
                    }
                })
                rawData = rawData.concat(kitData)
            }
            if (rawData.length === 0) {
                notify("No data to save", "warning")
                return
            }
            const response = await axiosInstance.post("/mfx/add/", rawData)
            if (response.data === 0) {
                notify("Mfx could not be saved. Please try again.", "error")
            } else {
                notify("Mfx Saved Successfully", "success")
            }

        } catch (error) {
            notify(error.message, "error")

        } finally {
            setLoading(false)
        }
    }
    const DashBoardSelect = () => {
        if (inputList && !loading) {
            return (
                <>
                    <ToastContainer/>

                    <DashBoardPanel inputList={inputList} kitUsed={kitUsed} outputList={outputList}
                                    processData={(_inputLists, _defectLists, _selectedMfxs, _selectedExps, _selectedDate, _selectedLocation) => processData(_inputLists, _defectLists, _selectedMfxs, _selectedExps, _selectedDate, _selectedLocation)}
                                    mfxList={mfxList.map(it => {
                                        return {
                                            id: it.id,
                                            name: it.name
                                        }
                                    })}
                                    expList={expList.map(it => {
                                        return {
                                            id: it.id,
                                            name: it.name
                                        }
                                    })}
                                    locationList={locationList}

                    />
                </>

            )
        } else {
            return null
        }
    }


    if (!loading && inputList && outputList && kitUsed) {
        return (
            <div className="min-h-screen bg-gray-50">
                <ToastContainer />
                <MunshiMenu handle={handle} />
                <main className="p-3 md:p-5">
                    <div className="surface-card shadow-2 border-round overflow-hidden">
                        <div className="p-3 bg-gray-100 border-bottom-1 border-gray-200">
                            <h2 className="text-lg font-semibold m-0 flex align-items-center">
                                <i className="pi pi-cog mr-2 text-blue-500"></i>
                                Production Management
                            </h2>
                        </div>
                        <div className="p-2 md:p-4">
                            <DashBoardSelect />
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}
